import script from "./side-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./side-bar.vue?vue&type=script&setup=true&lang=js"

import "./side-bar.vue?vue&type=style&index=0&id=43a8cd85&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a8cd85"]])

export default __exports__